namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;

    export interface IPrescriber {
		id: number | string;
        firstName: string;
        lastName: string;
        suffix: string;
        nickName: string;
        npi: string;
		taxId: string;

        addresses: Address[];
        emailAddresses: EmailAddress[];
        externalIds: ExternalId[];
        phoneNumbers: PhoneNumber[];
        prescriberLicenses: PrescriberLicense[];
        // sites: Site[];

		addAddress(index?: number): Address;
		addEmailAddress(index?: number): EmailAddress;
		addExternalId(index?: number): ExternalId;
		addPhoneNumber(index?: number): PhoneNumber;
		addPrescriberLicense(index?: number): PrescriberLicense;
		isValidSearch(): boolean;
		mapToPrescriberUpsearchModel(): psgm.PrescriberUpsearchModel;
	}

    export class Prescriber implements IPrescriber {
		id: number | string;
        firstName: string;
        lastName: string;
        middleName: string;
        suffix: string;
        nickName: string;
        npi: string;
		taxId: string;

        addresses: Address[];
        emailAddresses: EmailAddress[];
        externalIds: ExternalId[];
        phoneNumbers: PhoneNumber[];
        prescriberLicenses: PrescriberLicense[];
        // sites: Site[];

        constructor(obj?: IPrescriber | any) {
            this.id = null;
            this.firstName = '';
            this.lastName = '';
            this.middleName = '';
            this.suffix = '';
            this.nickName = '';
            this.npi = '';
			this.taxId = '';

            this.externalIds = [];
            this.addresses = [];
            this.emailAddresses = [];
			this.phoneNumbers = [];
			this.prescriberLicenses = [];
            // this.sites = [];

            if (obj) {
                this.id = obj.id || obj.prescriberId || null;
                this.firstName = obj.firstName || '';
                this.lastName = obj.lastName || '';
                this.middleName = obj.middleName || '';
                this.suffix = obj.suffix || '';
                this.nickName = obj.nickName || '';
                this.npi = obj.npi || '';
                this.taxId = obj.taxId || '';

                if (obj.externalIds) {
					for (const externalId of obj.externalIds) {
                        this.externalIds.push(new ExternalId(externalId));
                    }
                }

				if (obj.addresses) {
					for (const address of obj.addresses) {
                        this.addresses.push(new Address(address));
                    }
                }

				if (obj.emailAddresses) {
					for (const emailAddress of obj.emailAddresses) {
                        this.emailAddresses.push(new EmailAddress(emailAddress));
                    }
                }

				if (obj.phoneNumbers) {
					for (const phoneNumber of obj.phoneNumbers) {
						this.phoneNumbers.push(new PhoneNumber(phoneNumber));
					}
                }

                if (obj.prescriberLicenses) {
                    for (const prescriberLicense of obj.prescriberLicenses) {
                        this.prescriberLicenses.push(new PrescriberLicense(prescriberLicense));
                    }
                }

				//if (obj.sites) {
				//	for (const site of obj.sites) {
				//		this.sites.push(new Site(site));
				//	}
				//}
            }
		}

		addAddress(index: number = null): Address {
			const length = this.addresses.length;

			if (index && index < length) {
				return this.addresses[index];
			}

			const address = new Address();
			this.addresses.push(address);
			return address;
		}

		addEmailAddress(index: number = null): EmailAddress {
			const length = this.emailAddresses.length;

			if (index && index < length) {
				return this.emailAddresses[index];
			}

			const emailAddress = new EmailAddress();
			this.emailAddresses.push(emailAddress);
			return emailAddress;
		}

		addExternalId(index: number = null): ExternalId {
			const length = this.externalIds.length;

			if (index && index < length) {
				return this.externalIds[index];
			}

			const externalId = new ExternalId();
			this.externalIds.push(externalId);
			return externalId;
		}

		addPhoneNumber(index: number = null): PhoneNumber {
			const length = this.phoneNumbers.length;

			if (index && index < length) {
				return this.phoneNumbers[index];
			}

			const phoneNumber = new PhoneNumber();
			this.phoneNumbers.push(phoneNumber);
			return phoneNumber;
		}

		addPrescriberLicense(index: number = null): PrescriberLicense {
			const length = this.prescriberLicenses.length;

			if (index && index < length) {
				return this.prescriberLicenses[index];
			}

			const prescriberLicense = new PrescriberLicense();
			this.prescriberLicenses.push(prescriberLicense);
			return prescriberLicense;
		}

		isValidSearch(): boolean {
			let counter = 0;

			if (this.firstName) {
				counter++;
			}

			if (this.lastName) {
				counter++;
			}

			if (this.addresses) {
				if (this.addresses[0].city) {
					counter++;
				}

				if (this.addresses[0].state) {
					counter++;
				}

				if (this.addresses[0].zip) {
					counter++;
				}
			}

			return counter >= 1;
		}

		mapToPrescriberUpsearchModel(): psgm.PrescriberUpsearchModel {
			return <psgm.PrescriberUpsearchModel>{
				prescriberId: this.id,
				firstName: this.firstName,
				middleName: this.middleName,
				lastName: this.lastName,
				suffix: this.suffix,
				nickname: this.nickName,
				npi: this.npi,
				taxId: this.taxId,
				accountRelationshipIsPrimary: false,
				prescriberLicenses: _.map(this.prescriberLicenses, pl => {
					return {
						prescriberLicenseId: pl.prescriberLicenseId,
						licenseType: typeof pl.licenseType === 'number' ? pl.licenseType : Portico.Models.Gateway.PrescriberLicenseType[pl.licenseType],
						licenseNumber: pl.licenseNumber
					} as psgm.PrescriberLicenseUpsearchModel
				}),
				externalIds: this.externalIds &&
					this.externalIds.length > 0
					? _.map(this.externalIds, extId => {
						return ExternalId.prototype.mapToEnterpriseCoordinatorExternalId.call(extId);
					}) : [],
				addresses: this.addresses &&
					this.addresses.length > 0
					? _.map(this.addresses, addr => {
						return Address.prototype.mapToEnterpriseCoordinatorAddress.call(addr);
					}) : [],
				phoneNumbers: this.phoneNumbers &&
					this.phoneNumbers.length > 0
					? _.map(this.phoneNumbers, ph => {
						return PhoneNumber.prototype.mapToEnterpriseCoordinatorPhoneUpsearchModel.call(ph);
					}) : [],
				emailAddresses: this.emailAddresses &&
					this.emailAddresses.length > 0
					? _.map(this.emailAddresses, email => {
						return EmailAddress.prototype.mapToEnterpriseCoordinatorEmailAddress.call(email);
					}) : []
			};
		}
	}
}
